module.exports = __webpack_public_path__ + "img/george-dewey.366deadd.png";